// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#0075a7","primaryColorLight":"#0585bc","primaryColorLighter":"#20b0ed","primaryColorLightest":"#6bc7ef"};